import { render, staticRenderFns } from "./tab-item.vue?vue&type=template&id=34fc0210&scoped=true&lang=html&"
import script from "./tab-item.vue?vue&type=script&lang=js&"
export * from "./tab-item.vue?vue&type=script&lang=js&"
import style0 from "./tab-item.vue?vue&type=style&index=0&id=34fc0210&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fc0210",
  null
  
)

component.options.__file = "tab-item.vue"
export default component.exports